export const centsToDollars = v => +(v / 100);

export const formatCents = v => `$${centsToDollars(v).toFixed(2)}`;
